// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__10kY9","item":"PaymentsMobile_item__eXUGH","label":"PaymentsMobile_label__3f41R","amount":"PaymentsMobile_amount__2iqqH"};